import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export const DeactivateMandateModal = ({
  show,
  toggle,
  handleResumeMandate,
  isResuming,
}) => {
  //   const [resumption, setIsResumption] = useState();
  const navigate = useNavigate();
  return (
    <Modal show={show} onHide={toggle} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <div>
          <Modal.Title>Deactivate Mandate</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to deactivate this mandate?</p>
        {/* <Form>
          <Form.Label>Resumption Date</Form.Label>
          <Form.Control
            type="date"
            value={resumption}
            onChange={(e) => setIsResumption(e.target.value)}
          />
        </Form> */}
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{
            backgroundColor: "red",
            fontSize: "0.8rem",
            fontWeight: 500,
            border: 0,
          }}
          onClick={() => {
            handleResumeMandate();
          }}
          disabled={isResuming}
        >
          {isResuming ? "Deactivating, please wait.." : "Deactivate"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
